// bernie
import { Store } from 'bernie-plugin-mobx';
import { SerializedData } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

import { UnsubscribeSource } from '../sources';

// data

export class UnsubscribeStore extends Store {
  constructor(private unsubscribeSource: UnsubscribeSource, state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this.unsubscribeSource, data.unsubscribeSource);
  }

  public async setUnsubscribed(email: string) {
    return await this.unsubscribeSource.setUnsubscribe(email);
  }
}
